import React,{ useEffect,useState } from 'react';
import { Card, Avatar, Statistic, Row, Col, List, Empty, Popconfirm, message, Flex, Tag, Image } from 'antd';
import { LikeOutlined, FileTextOutlined, TrophyOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import PostDetail from './PostDetail';
import { size } from 'lodash';
import { API_BASE_URL } from '../config';
import { Typography } from 'antd';
const { Paragraph, Text } = Typography;

const Profile = ({ selectedPostId,onLike,onBack,onRefresh,scrollToComments, user, posts, onPostClick}) => {
  const [tagsDatata, setTagsDatata] = React.useState([]);
  const [homeData, setHomeData] = useState();
  const searchlableta = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search_lableta`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userid: user.userId
        })
      });
      const data = await response.json();
      if(data){
        console.log("他获得的点赞标签数据：",data);
        setTagsDatata(data)
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };
  const homedetail = async (userid) => {
    try {
      const response = await fetch(`${API_BASE_URL}/database/search_homedetail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userid: userid,
        })
      });
      const data = await response.json();
      if(data){
        setHomeData(data);
      }
    } catch (error) {
      console.error('获取数据失败:', error);
    }
  };
  useEffect(() => {
    if(user){
      searchlableta();
      homedetail(user.userId);
    }
  }, [user]);

  if (!user) {
    return (
      <div style={{ textAlign: 'center', padding: '50px 0' }}>
        <Empty description="加载用户信息中..." />
      </div>
    );
  }
  
  // 计算总获赞数
  const totalLikes = posts.reduce((sum, post) => sum + post.likecounts, 0);
  const selectedPost = posts.find(post => post.vp_id === selectedPostId);

  return (
    <>
    {selectedPostId ? (
        <PostDetail
          post={selectedPost}
          currentUser={user}
          onLike={onLike}
          onBack={onBack}
          onRefresh={onRefresh}
          scrollToComments={scrollToComments}
        />
        ) : (
    <div>
      <Card bordered={true} style={{ marginBottom: 16 }}>
        <div style={{ textAlign: 'center', padding: 20 }}>
          <Avatar 
            src={user.avatar}
            alt={user.name}
            size={100}
            style={{ marginBottom: 16 }}
          />
          <h2 style={{ margin: 0, marginBottom: 8 }}>{user.name}</h2>
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
            <Col span={8}>
              <Statistic 
                title="获得点赞" 
                value={homeData?.likes} 
                icon={<LikeOutlined />} 
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="被value的次数" 
                value={homeData?.values} 
                icon={<TrophyOutlined />} 
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="发布内容" 
                value={size(posts)} 
                icon={<FileTextOutlined />} 
              />
            </Col>
          </Row>
        </div>
      </Card>
      <Card style={{ marginBottom: 16 }}>
        <Flex gap={4} wrap >
          <span style={{ fontSize: '16px' }}>获得标签 :  </span>
          {tagsDatata.map(tag => (
            <Tag
              key={tag.value}
              color='blue'
              style={{ fontSize: '16px' }}
            >
              {tag.value} +{tag.count}

            </Tag>
          ))}
        </Flex>
        <br />
        <Paragraph style={{ fontSize: '16px' }}>
          邮件签名：
          <Image style={{ verticalAlign: 'bottom' }} src="data:image/jpeg;base64,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" data-alimail-img-processed-sqm-editor="true" />
          <Image style={{ verticalAlign: 'bottom' }} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC/ElEQVRYhe2XS2xMURjHf9+9d1CPBalHxKuothH1ilfCwo6wsLBokHiGCAnChpARQiNpDKGsiKRpYmFhIbUQFh6xqJV4RERUlbbTaulLOzPnfhadaeZxdaZm2pX/Zs75ny/f/3fOvXMyA/+VA6mq8/Wr5g1ac+bIKi/fyja8rlHXf2vls5VHsKFFj3mGnz5cgMgNBck5gO1jhwgzgPEiVNQFdWNqlVOGspSzRxYlr6QQDVUNrXpB4FRsrlA7I19Wqt9vEWlbie2UoexHyAOtB7mMCd2XC5VfIAcnIG5iD4Hlnxt1DvyYhu3sQ3VHfziAzEL1ILZvl/r9TrQ+OzUE9Y5Y7Iz3XJdNM6dIDUDTiRPjpuaZewgbUD3O+SsBAY3VZn8CQmmyZ8GE2HhaRUU3ll5CtZ0uuRkfnjXA93adjbA42XehI8Fo7HmBcF0Cgd8pG8gGoL5FA7ZwNMnWMCycky/vM+nxzyfwpVEXWnDQY6mzq4lPmfYZOIFtJyN7BdalqQ+FwuHya/4x3aaPp0BRcoEqn4DK2DziIsGfjI6mdY8SHi8plLexdSeO5Bzo9HTEJXN9juljtVc4gAjzgMvxTEajG1X4DZHaj7pnRaFUQeIjyOh9KCqQ3UBJJrUAqimWY1wuqqqdDDAsclMBAPI/fGDsiABEjIepvCsuls4RAegLp3qWcGtgPMz52usB4MLaEQHoCYFxU19uEXwjAaAdPR6uYHwWt4cdoKsXQhGPX0DC82Xz5eGwAoQN+tNr9/0alQCU63Djoi0d4Ho8ewCBmiEBlC4QDpXZWlJgeV8pcYoYtPkXRMxfwoWqFYWUDwngwFZb15SK7N4yaKn2hAYPj+quiCRcTWkBPtZr9NP1aqy9YTT4C1o7EK+v3ECQxTOnk0fJvuNVHK+r1UYmT4SW9v55sE2fCLwMudDeBb2hdB3AsqkzY6hetUBSrqUBAEVfo0xKLlCF5h/9YxHMqzcEjm2XB+ljM1Pckals9jPo3yvThnl4TfpyFf5fAH8AXxEVBnmSn40AAAAASUVORK5CYII=" data-alimail-img-processed-sqm-editor="true" />
          <Text style={{ fontSize: '16px' }} copyable={{
            text: `<div style="clear: both;">
            <a href="dingtalk://dingtalkclient/page/link?url=https%3A%2F%2Fvalue.hainatravel.com%3Fu2%3D${user.userId}%26actionId%3Dhome&amp;pc_slide=true" target="_blank">
            <img style="vertical-align: bottom;" src="data:image/jpeg;base64,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" data-alimail-img-processed-sqm-editor="true" /></a>
             <a href="dingtalk://dingtalkclient/page/link?url=https%3A%2F%2Fvalue.hainatravel.com%3Fu2%3D${user.userId}%26actionId%3Dlikehome&amp;pc_slide=true" target="_blank"><img style="vertical-align: bottom;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC/ElEQVRYhe2XS2xMURjHf9+9d1CPBalHxKuothH1ilfCwo6wsLBokHiGCAnChpARQiNpDKGsiKRpYmFhIbUQFh6xqJV4RERUlbbTaulLOzPnfhadaeZxdaZm2pX/Zs75ny/f/3fOvXMyA/+VA6mq8/Wr5g1ac+bIKi/fyja8rlHXf2vls5VHsKFFj3mGnz5cgMgNBck5gO1jhwgzgPEiVNQFdWNqlVOGspSzRxYlr6QQDVUNrXpB4FRsrlA7I19Wqt9vEWlbie2UoexHyAOtB7mMCd2XC5VfIAcnIG5iD4Hlnxt1DvyYhu3sQ3VHfziAzEL1ILZvl/r9TrQ+OzUE9Y5Y7Iz3XJdNM6dIDUDTiRPjpuaZewgbUD3O+SsBAY3VZn8CQmmyZ8GE2HhaRUU3ll5CtZ0uuRkfnjXA93adjbA42XehI8Fo7HmBcF0Cgd8pG8gGoL5FA7ZwNMnWMCycky/vM+nxzyfwpVEXWnDQY6mzq4lPmfYZOIFtJyN7BdalqQ+FwuHya/4x3aaPp0BRcoEqn4DK2DziIsGfjI6mdY8SHi8plLexdSeO5Bzo9HTEJXN9juljtVc4gAjzgMvxTEajG1X4DZHaj7pnRaFUQeIjyOh9KCqQ3UBJJrUAqimWY1wuqqqdDDAsclMBAPI/fGDsiABEjIepvCsuls4RAegLp3qWcGtgPMz52usB4MLaEQHoCYFxU19uEXwjAaAdPR6uYHwWt4cdoKsXQhGPX0DC82Xz5eGwAoQN+tNr9/0alQCU63Djoi0d4Ho8ewCBmiEBlC4QDpXZWlJgeV8pcYoYtPkXRMxfwoWqFYWUDwngwFZb15SK7N4yaKn2hAYPj+quiCRcTWkBPtZr9NP1aqy9YTT4C1o7EK+v3ECQxTOnk0fJvuNVHK+r1UYmT4SW9v55sE2fCLwMudDeBb2hdB3AsqkzY6hetUBSrqUBAEVfo0xKLlCF5h/9YxHMqzcEjm2XB+ljM1Pckals9jPo3yvThnl4TfpyFf5fAH8AXxEVBnmSn40AAAAASUVORK5CYII=" data-alimail-img-processed-sqm-editor="true" />
  </a></div>`,
        icon: [
            <span key="copy" style={{ fontSize: '16px' }}>点击复制</span>,
            <span key="copied" style={{ fontSize: '16px' }}>已复制</span>
          ],
          }}
          >
          </Text>
        </Paragraph>
      </Card>
      <Card title="我的发布" bordered={true}>
        {size(posts) === 0 ? (
          <div style={{ textAlign: 'center', padding: '50px 0' }}>
            <Empty description="你还没有发布任何内容" />
          </div>
        ) : (
          <List
            pagination={{
              onChange: page => {
                console.log(page);
              },
              pageSize: 3,
            }}
            itemLayout="vertical"
            dataSource={posts}
            renderItem={item => (
              <List.Item
                actions={[
                  <span><LikeOutlined /> {item.likecounts} 赞</span>,
                  <Popconfirm
                    title="确定要删除这条内容吗？"
                    onConfirm={async () => {
                      const response = await fetch(`${API_BASE_URL}/posts/delete_posts`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                          vp_id: item.vp_id
                        })
                      });
                      const result = await response.json();
                      console.log("删除帖子结果:", result);
                      if (result) {
                        message.success('删除成功');
                        // 重新获取帖子信息
                        if (onRefresh) {
                          onRefresh();
                        }
                      } else {
                        message.error('删除失败，发布后两分钟内才能删除');
                      }
                    }}
                    okText="确定"
                    cancelText="取消"
                  >
                    <span style={{ cursor: 'pointer', color: '#ff4d4f' }}>
                      <DeleteOutlined /> 删除
                    </span>
                  </Popconfirm>
                ]}
              >
                <List.Item.Meta
                  title={item.vp_title}
                  description={item.vp_datetime}
                  onClick={() => onPostClick(item.vp_id)}
                />
                <div onClick={() => onPostClick(item.vp_id)} style={{ marginTop: '10px',  display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <div dangerouslySetInnerHTML={{ __html: item.vp_content.replace(/<img[^>]*>/g, '') }} />
                </div>
              </List.Item>
            )}
          />
        )}
      </Card>
    </div>
      )}
      </>
  );
};

export default Profile;
